/*eslint-disable*/
'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var assign = require('object-assign');
var dataset = require('dataset');
var velocity = require('velocity-animate');
var classie = require('desandro-classie');
var getClosest = require('./get-closest');
var Accordion = function () {
  function Accordion() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Accordion);
    this.config = assign({}, {
      // defaults
      transitionIn: 'slideDown',
      transitionOut: 'slideUp',
      transitionDuration: 500,
      transitionEasing: 'swing',
      sectionClass: 'accordion-section',
      triggerClass: 'accordion-trigger',
      contentClass: 'accordion-content',
      closeOthers: false,
      headerIcon: true,
      scrollToContent: false,
      scrollSpeed: 500,
      scrollOffset: 0,
      closeIcon: 'fa-chevron-up',
      openIcon: 'fa-chevron-down',
      onOpen: function onOpen() {},
      onClose: function onClose() {},
      afterOpen: function afterOpen() {},
      afterClose: function afterClose() {}
    }, config);
  }
  _createClass(Accordion, [{
    key: 'bindEvents',
    value: function bindEvents() {
      var _this = this;
      var triggerClass = this.config.triggerClass;
      var _accordionTrigger = Array.from(document.querySelectorAll('.' + triggerClass));
      _accordionTrigger.forEach(function (el) {
        el.addEventListener('click', _this.triggerAccordion.bind(_this));
        el.addEventListener('touch', _this.triggerAccordion.bind(_this));
      });
    }
  }, {
    key: 'triggerAccordion',
    value: function triggerAccordion(e) {
      if (e.currentTarget.tagName === 'A') {
        e.preventDefault();
      }
      var _config = this.config,
        sectionClass = _config.sectionClass,
        triggerClass = _config.triggerClass,
        headerIcon = _config.headerIcon;
      this._trigger = getClosest(e.currentTarget, '.' + triggerClass);
      if (headerIcon) {
        this._chevron = this._trigger.querySelector('.fa');
      }
      this._accordionSection = getClosest(this._trigger, '.' + sectionClass);
      var _targetId = dataset(this._trigger, 'accordion').slice(1);
      this._target = document.getElementById(_targetId);
      if (classie.has(this._accordionSection, sectionClass + '--open')) {
        this.closeAccordion();
      } else {
        this.openAccordion();
      }
    }
  }, {
    key: 'openAccordion',
    value: function openAccordion() {
      var _this2 = this;
      var _config2 = this.config,
        transitionIn = _config2.transitionIn,
        transitionOut = _config2.transitionOut,
        transitionDuration = _config2.transitionDuration,
        onOpen = _config2.onOpen,
        afterOpen = _config2.afterOpen,
        transitionEasing = _config2.transitionEasing,
        closeOthers = _config2.closeOthers,
        sectionClass = _config2.sectionClass,
        contentClass = _config2.contentClass,
        headerIcon = _config2.headerIcon,
        scrollToContent = _config2.scrollToContent,
        scrollSpeed = _config2.scrollSpeed,
        scrollOffset = _config2.scrollOffset,
        closeIcon = _config2.closeIcon,
        openIcon = _config2.openIcon;
      if (closeOthers) {
        var parentAccordion = this._accordionSection.parentNode;
        var _otherAccordions = Array.from(parentAccordion.querySelectorAll('.' + sectionClass + '.' + sectionClass + '--open'));
        _otherAccordions.forEach(function (el) {
          var _otherContent = el.querySelector('.' + contentClass);
          velocity(_otherContent, transitionOut, {
            duration: transitionDuration,
            easing: transitionEasing,
            display: 'none',
            begin: function begin() {
              if (headerIcon) {
                var _otherChevron = el.querySelector('.fa');
                classie.add(_otherChevron, openIcon);
                classie.remove(_otherChevron, closeIcon);
              }
            },
            complete: function complete() {
              classie.remove(el, sectionClass + '--open');
            },
            promiseRejectEmpty: false
          });
        });
      }
      velocity(this._target, transitionIn, {
        duration: transitionDuration,
        easing: transitionEasing,
        display: 'block',
        begin: function begin() {
          if (headerIcon) {
            classie.add(_this2._chevron, closeIcon);
            classie.remove(_this2._chevron, openIcon);
          }
          onOpen();
        },
        complete: function complete() {
          classie.add(_this2._accordionSection, sectionClass + '--open');
          if (scrollToContent) {
            velocity(_this2._target, 'scroll', {
              duration: scrollSpeed,
              easing: transitionEasing,
              offset: scrollOffset
            });
          }
          afterOpen();
        },
        promiseRejectEmpty: false
      });
    }
  }, {
    key: 'closeAccordion',
    value: function closeAccordion() {
      var _this3 = this;
      var _config3 = this.config,
        transitionOut = _config3.transitionOut,
        transitionDuration = _config3.transitionDuration,
        onClose = _config3.onClose,
        afterClose = _config3.afterClose,
        transitionEasing = _config3.transitionEasing,
        headerIcon = _config3.headerIcon,
        openIcon = _config3.openIcon,
        closeIcon = _config3.closeIcon,
        sectionClass = _config3.sectionClass;
      velocity(this._target, transitionOut, {
        duration: transitionDuration,
        easing: transitionEasing,
        display: 'none',
        begin: function begin() {
          if (headerIcon) {
            classie.remove(_this3._chevron, closeIcon);
            classie.add(_this3._chevron, openIcon);
          }
          onClose();
        },
        complete: function complete() {
          classie.remove(_this3._accordionSection, sectionClass + '--open');
          afterClose();
        },
        promiseRejectEmpty: false
      });
    }
  }, {
    key: 'getEventTarget',
    value: function getEventTarget() {
      return this._trigger || false;
    }
  }]);
  return Accordion;
}();
module.exports = Accordion;